<template>
  <div>
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>
    <v-container class="container mt-10 mb-12 pb-12" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="10" md="8" lg="6" xl="5">
          <PaymentForm :profile="profile" :selectedGiftCard="giftCard">
          </PaymentForm>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PaymentForm from "../components/forms/PaymentForm.vue";

export default {
  metaInfo: {
    title: "Dagajoga voucher - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "GiftCardPayment",
  components: {
    PaymentForm,
  },
  computed: {
    giftCard() {
      return this.$store.getters["giftCard/getGiftCardForPayment"];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  async created() {
    this.$store.commit("payment/SET_INIT_VALUES");
    this.$store.dispatch("giftCard/setGiftCardForPayment", {
      id: this.$route.query.id,
    });
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");
  },
  destroyed() {
    this.$store.commit("payment/SET_INIT_VALUES");
  },
};
</script>
